import { gql } from "@apollo/client"

export const TierFeaturesSectionApplylistFragment = gql`
    fragment TierFeaturesSectionApplylist on ApplylistType {
        id
        partnershipBenefits {
            id
            name
            description
        }
        group {
            id
            placementAmount
            placementIsPercentage
        }
    }
`

export const TierFeaturesSectionCollectivePassFragment = gql`
    fragment TierFeaturesSectionCollectivePass on CollectivePassType {
        id
        isFeatured
        isHighlightedTier
        activeJobPostLimit
        introRequestLimit
        unlimitedIntroRequests
        additionalBenefits(onlyEnabled: true) {
            id
            benefit {
                id
                name
            }
        }
    }
`
